import { Button } from './Button'

export const PAGE_SIZE_OPTIONS = [10, 50, 100, 500] as const
export type PageSize = (typeof PAGE_SIZE_OPTIONS)[number]

interface PaginationProps {
  page: number
  pageSize: PageSize
  total: number
  onPageChange: (page: number) => void
  onPageSizeChange: (size: PageSize) => void
  itemLabel?: string
}

export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  itemLabel = 'rezultate',
}: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  const start = total === 0 ? 0 : page * pageSize + 1
  const end = Math.min((page + 1) * pageSize, total)

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 text-xs">
      <div className="flex items-center gap-2">
        <span className="text-b4l-text-muted">Per pagină:</span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value) as PageSize)}
          className="rounded border border-b4l-border bg-b4l-surface px-2 py-1 text-xs"
        >
          {PAGE_SIZE_OPTIONS.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>

      <div className="text-b4l-text-muted">
        {total === 0 ? (
          `0 ${itemLabel}`
        ) : (
          <>
            <span className="font-medium text-b4l-text">
              {start.toLocaleString('ro-RO')}–{end.toLocaleString('ro-RO')}
            </span>{' '}
            din <span className="font-medium text-b4l-text">{total.toLocaleString('ro-RO')}</span>{' '}
            {itemLabel} · pagina {page + 1} / {totalPages}
          </>
        )}
      </div>

      <div className="flex gap-1">
        <Button variant="secondary" onClick={() => onPageChange(0)} disabled={page === 0}>
          ‹‹
        </Button>
        <Button
          variant="secondary"
          onClick={() => onPageChange(Math.max(0, page - 1))}
          disabled={page === 0}
        >
          ‹
        </Button>
        <Button
          variant="secondary"
          onClick={() => onPageChange(page + 1)}
          disabled={page + 1 >= totalPages}
        >
          ›
        </Button>
        <Button
          variant="secondary"
          onClick={() => onPageChange(totalPages - 1)}
          disabled={page + 1 >= totalPages}
        >
          ››
        </Button>
      </div>
    </div>
  )
}
